import(/* webpackMode: "eager" */ "/app/src/app/workbench/page.tsx");
